import axios from 'axios';

/**
 * 获取数据
 */
export function getJSONData(adcode) {
    return axios.get(process.env.VUE_APP_MAP_BASE_URL + '/areas_v3/bound/' + adcode + '_full.json');
}
